<template>
    <div
        :class="{
            [theme.wrapper]: true,
            [theme.header]: filter.location === 'header',
            [theme.menu]: filter.location !== 'header',
        }"
    >
        <div :class="theme.group">
            <div :class="theme.label">
                {{ filter.label }}
            </div>

            <div :class="theme.field">
                <div :class="theme.header">
                    <span class="hyperlink" @click="selectAll">Select All</span>
                    <span :class="theme.spacer">|</span>
                    <span class="hyperlink" @click="clear">Clear</span>
                </div>

                <ul>
                    <li
                        v-for="option in options"
                        :key="option.key + option.value"
                        :class="{
                            [theme.checked]: option.checked,
                            [theme.unchecked]: !option.checked,
                        }"
                    >
                        <input
                            v-model="option.checked"
                            type="checkbox"
                            :checked="option.checked"
                        />

                        {{ option.key }}
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
import Common from './mixins/Common.vue';

export default {
    mixins: [Common],
    props: {
        data: Object,
        filter: Object,
    },
    data() {
        return {
            checkAll: true,
            options: this.filter.options.map(option => {
                return {
                    checked: this.filter.current_value.includes(option.value),
                    ...option,
                };
            }),
        };
    },
    computed: {
        checkedOptions() {
            return this.options.filter(x => x.checked);
        },
        uncheckedOptions() {
            return this.options.filter(x => !x.checked);
        },
        isActive() {
            return this.filter.current_value.length !== this.options.length;
        },
    },
    watch: {
        checkedOptions: function (options) {
            this.filter.current_value = options.map(x => x.value);

            if (this.isActive) {
                let value = this.uncheckedOptions[0].key;
                let expandedValue = '';

                if (this.uncheckedOptions.length > 1) {
                    value += `... (+${this.uncheckedOptions.length - 1})`;
                    expandedValue = this.uncheckedOptions
                        .map(x => `- ${x.key}`)
                        .join('<br>');
                }

                this.filter.display_data = [
                    {
                        label: this.filter.label,
                        operator: ' != ',
                        value,
                        expandedValue,
                    },
                ];
            } else {
                this.filter.display_data = [];
            }

            this.bus.$emit('filter-changed');
        },
    },
    methods: {
        selectAll() {
            this.options.forEach(x => (x.checked = true));
        },
        clear() {
            this.options.forEach(x => (x.checked = false));
        },
        getCurrentKey() {
            return this.filter.options.find(
                x => x.value === this.filter.current_value,
            ).key;
        },
    },
};
</script>

<style lang="scss" module></style>
<style
    lang="scss"
    module="theme_default"
    src="./../css/themes/default/check_list_filter.scss"
></style>
<style
    lang="scss"
    module="theme_simple"
    src="./../css/themes/simple/check_list_filter.scss"
></style>
